import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=1fe72fa8&"
import script from "./ProductMain.vue?vue&type=script&lang=js&"
export * from "./ProductMain.vue?vue&type=script&lang=js&"
import style0 from "./ProductMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports